import LoadingStepSkeleton from "@libs/acp/components/LoadingStepSkeleton";
import { Flows, type FormType } from "@libs/acp/flows/types";
import type { AnySchema } from "valibot";

export const flowInitialState = {
	currentStep: "",
	lastVisitedStep: "",
	CurrentStepComponent: LoadingStepSkeleton,
	currentSchemaFormValidation: {} as AnySchema,
	schemasFormValidations: {} as { [key: string]: AnySchema },
	firstStepName: "",
	lastStepName: "",
	stepsName: [],
	flowId: "",
	formState: {},
	schemaStepsComponents: {},
	activeSchemaStepsComponents: {},
	activeFlows: [Flows.SIGNIN_UNIFIED],
	isLoading: false,
	isValid: false,
	formType: "" as FormType,
};
